import React from 'react';
import { EntityId } from '@reduxjs/toolkit';
import { HeartIcon } from '@cp/ds/src/icons/heart';
import { HeartFilledIcon } from '@cp/ds/src/icons/heartFilled';
import { ListItemIcon, ListItemText, MenuItem, MenuItemProps } from '@cp/ds/src/components/menuList';
import { useIsClientFavorite } from '@cp/entities/client/current/favorite';
import { useQueryFavorites, useToggleFavorite } from '../model';

export interface ToggleTextProps extends MenuItemProps {
  clientId: EntityId;
}

export const ToggleMenuItem: React.FC<ToggleTextProps> = ({ clientId, ...props }) => {
  const isFavorite = useIsClientFavorite(clientId);
  const onClick = useToggleFavorite(clientId);
  useQueryFavorites();
  return (
    <MenuItem onClick={onClick} {...props}>
      <ListItemIcon>{isFavorite ? <HeartFilledIcon /> : <HeartIcon />}</ListItemIcon>
      <ListItemText>{isFavorite ? 'Убрать из избранных' : 'Сделать избранным'}</ListItemText>
    </MenuItem>
  );
};
